import DashboardPanel from "@/components/dashboard";
import { sessionQueryOptions } from "@/lib/query-options";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(dashboard)/_authenticated/$companyId/")(
  {
    component: DashboardPanel,
    beforeLoad: async ({ context, params }) => {
      const queryClient = context.queryClient;
      const { companyId } = params;

      try {
        const session = await queryClient.ensureQueryData(sessionQueryOptions);

        const isGlobalAdmin = session?.user?.role === "admin";

        const isCompanyAdmin = session?.user.companies?.find(
          (c) => c.id === companyId,
        )?.isAdmin;

        if (!isGlobalAdmin && !isCompanyAdmin) {
          throw redirect({
            to: "/",
            replace: true,
          });
        }
      } catch (error) {
        console.error("Failed to fetch session or check permissions:", error);
        throw redirect({
          to: "/login",
          replace: true,
        });
      }
    },
  },
);
